// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__phRzL","dragIcon":"SortableItem_dragIcon__jrT4S","disabled":"SortableItem_disabled__3Ug-D"};